
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightFlashlightOff as ObiLightFlashlightOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-flashlight-off.js';
 
 
 

 
 export const ObiLightFlashlightOff = createComponent({
   react: React,
   tagName: 'obi-light-flashlight-off',
   elementClass: ObiLightFlashlightOffElement,
   events: {
     
   }
  });
 
 